import { ResetPasswordTemplate, MainLayout } from "@/design-system/Templates";
import Header from "@/design-system/Organisms/Header";
import { headerConfig } from "@/design-system/Organisms/Header/Header.config";
import { Footer } from "@/design-system/Organisms";

const Login = () => (
    <MainLayout
        header={<Header {...headerConfig} />}
        sidebar={null}
        className=""
        footer={<Footer />}
    >
        <ResetPasswordTemplate />
    </MainLayout>
);

export default Login;
